export default __webpack_public_path__ + "static/media/Legguards of the Black Warden.26daf736.jpg";